import * as React from 'react';
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { Action } from 'app/pages/AgentPricing/actionTypes';
import { getRatesTable, getRatesHighlightInfo } from 'app/pages/AgentPricing/modules/RatesTableWidget/selectors';
import { RatesTable, RatesColumn } from 'app/pages/AgentPricing/models';
import { RatesHighlight } from 'app/pages/AgentPricing/modules/RatesTableWidget/state';
import { changeRate, changeStartDate } from 'app/pages/AgentPricing/actions';
import { RatesTableWidget } from 'app/pages/AgentPricing/components/RatesTableWidget/RatesTableWidget';
import { getSelectedPublishedVersion } from 'app/pages/AgentPricing/modules/PublishedVersions';

export interface PublishedRatesTableProps {
}

interface StateProps {
    table: RatesTable, 
    readonly: boolean
    columns: RatesColumn[], 
    highlightInfo: RatesHighlight
}

interface DispatchProps {
    onChangeRate: (columnId: string, rowId: string, rate: string) => void,
    onChangeStartDate: (newDate: string) => void
}

const mapStateToProps = (state: any, ownProps: PublishedRatesTableProps) => {
    const highlightInfo : RatesHighlight = { }
    const selectedVersion = getSelectedPublishedVersion(state); 

    if (!selectedVersion) {
        return {
            readonly: true,
            table: {},
            columns: [],
            highlightInfo: highlightInfo,
        };
    }

    let columns : RatesColumn[] = []; 
    selectedVersion.rates.countries.forEach((x) => {
        columns = columns.concat(x.columns); 
    })
    const rateTable = selectedVersion.rates; 
    
    return { 
        readonly: true,
        table: rateTable, 
        columns: columns,
        highlightInfo: highlightInfo
    }
};

const mapDispatchToProps = (dispatch:Dispatch<Action>, ownProps: PublishedRatesTableProps) : DispatchProps => {
    return {
        onChangeRate: (columnId: string, rowId: string, rate: string) => {
            dispatch(changeRate(columnId, rowId, rate));
        },
        onChangeStartDate: (newDate: string) => {
            dispatch(changeStartDate(newDate));
        },
    };
}

export const PublishedRatesTable = connect(mapStateToProps, mapDispatchToProps)(({ table, columns, highlightInfo, onChangeRate, onChangeStartDate }: StateProps & DispatchProps) => {
    if (!table || columns.length === 0) {
        return <div>Loading...</div>;
    }

    return (
        <RatesTableWidget
            table={table}
            columns={columns}
            highlightInfo={highlightInfo}
            onChangeRate={onChangeRate}
            onChangeStartDate={onChangeStartDate}
        />
    );
});
